import { createFileRoute } from '@tanstack/react-router'
import { CompanyEditorPage } from '@/features/companies/editor'

export const Route = createFileRoute('/companies_/new')({
  component: CompanyEditorPage,
})
